import { Component, OnInit } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {LanguageService} from '../../services/language.service'; 
import {environment as env} from '../../../environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  errMsg:string;
  errMsg_ar:string;
  ptoken:string;
  sucsMsg:string;
  sucsMsg_ar:string;
  isLoading:boolean;
  showLang:string;

  constructor(private http:HttpClient,private route:ActivatedRoute,
    private router:Router,private langObj:LanguageService) { 
      this.langObj.langStr.subscribe((data)=>{ 
        this.showLang = data;
      });
    }

  ngOnInit(): void {
    this.sucsMsg='';
    this.ptoken = localStorage.getItem('p_token');
    if(this.ptoken == null || this.ptoken == undefined){
      this.router.navigate(['/']);
    }

    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

  }

  reResetPass(np, cp){
    if(np =='' || cp ==''){
      this.errMsg = "Enter password and confirm password";
      this.errMsg_ar = "أدخل كلمة المرور وتأكيد كلمة المرور";
    }else{
      if(np === cp){
        this.isLoading = true;
        this.http.post(env.apiurl+'updatePassword', {
          token:this.ptoken,
          password:np
        }).subscribe(rawData=>{
          this.isLoading = false;
          localStorage.removeItem('p_email');
          localStorage.removeItem('p_uid');
          localStorage.removeItem('p_token');
          if(rawData['success']){
            this.errMsg='';
            this.sucsMsg = rawData['message'];
            this.sucsMsg_ar = rawData['message_ar'];
          }else{
            this.errMsg = rawData['message'];
            this.errMsg_ar = rawData['message_ar'];
          }
        });
      }else{
        this.errMsg = "Password does not match";
        this.errMsg_ar = "كلمة السر غير متطابقة";
      }
    }
  }

}
